import Name from './Name';
import Created from './Created';
import Updated from './Updated';
import Id from './Id';
import ExtraFields from './ExtraFields'

export const labels = {
  Id: 'Id',
  Name: 'Név',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  ExtraFields: 'Extra mezők'
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'ExtraFields',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'ExtraFields',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Name,
  Updated,
  Created,
  Id,
  ExtraFields,
};
